import * as React from "react";
const SvgFiRrLips = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lips_svg__a)">
      <path
        fill="#062147"
        d="M23.547 10.33c-2.025-3.282-4.577-5.646-6.289-6.763a3.28 3.28 0 0 0-1.815-.562h-.023c-.927.007-1.726.32-2.312.905l-1.116 1.099-1.1-1.1A3.1 3.1 0 0 0 8.692 3c-.709 0-1.364.183-1.893.528-1.607 1.05-4.23 3.459-6.333 6.793A3.01 3.01 0 0 0 .6 13.745c.777 1.044 4.98 6.254 11.4 6.254 6.418 0 10.622-5.22 11.4-6.266a3.02 3.02 0 0 0 .146-3.404zM7.893 5.203c.2-.131.484-.203.8-.203.297 0 .577.115.785.323l1.1 1.099c.76.761 2.085.76 2.844 0l1.1-1.099c.26-.261.64-.318.912-.32.245.013.487.078.73.237 1.464.956 3.627 2.953 5.433 5.75-.869-.165-5.44-.991-9.598-.991s-8.647.801-9.575.975c1.768-2.673 3.99-4.808 5.468-5.773zM12 18c-4.747 0-8.207-3.542-9.388-4.941C3.852 13.285 8.075 14 12 14s8.122-.708 9.376-.935C20.183 14.477 16.731 18 12 18"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lips_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLips;
